<template>

    <m-edit1/>

    <m-factor-10 v-bind='{...{"showLogo":true,"showSiteNameInsteadOfLogo":false,"showDeliveryOption":true,"showCartonSize":false,"showOrderFormAnswers":true},...{}}' :style='""' class="px-5" ></m-factor-10><m-single-page-1 v-bind='{...{"contentLink":"terms"},...{}}' :style='""' class="terms-factor container mb-4" ></m-single-page-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mFactor10 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor10'; import mSinglePage1 from '@moeinmdn/miw-alpha-components/src/package/Page/Single/SinglePage1';

export default {
    name: 'HomeView',
    components: {mEdit1, mFactor10,mSinglePage1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
